var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdndroid03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 180,
    viewBox: "0 0 227 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1466_184667)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226.667,
    height: 180,
    rx: 7.05882,
    fill: "#EEF5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 186,
    height: 229,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 139,
    height: 27,
    rx: 13.5,
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 56,
    width: 170,
    height: 139,
    rx: 12,
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 24,
    width: 27,
    height: 27,
    rx: 13.4623,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 24,
    width: 27,
    height: 27,
    rx: 13.4623,
    fill: "#5E7DE8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.25 37.5C178.25 38.1904 178.81 38.75 179.5 38.75C180.19 38.75 180.75 38.1904 180.75 37.5C180.75 36.8096 180.19 36.25 179.5 36.25C178.81 36.25 178.25 36.8096 178.25 37.5ZM184.5 38.75C183.81 38.75 183.25 38.1904 183.25 37.5C183.25 36.8096 183.81 36.25 184.5 36.25C185.19 36.25 185.75 36.8096 185.75 37.5C185.75 38.1904 185.19 38.75 184.5 38.75ZM189.5 38.75C188.81 38.75 188.25 38.1904 188.25 37.5C188.25 36.8096 188.81 36.25 189.5 36.25C190.19 36.25 190.75 36.8096 190.75 37.5C190.75 38.1904 190.19 38.75 189.5 38.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1466_184667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226.667,
    height: 180,
    rx: 7.05882,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdndroid03);
export default __webpack_public_path__ + "static/media/adndroid03.9eddcd28f8a9a303af300fee83dd3c37.svg";
export { ForwardRef as ReactComponent };